import { processingSessionIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";

export const abandonProcessingSession = {
  name: "abandonProcessingSession" as const,
  input: z.object({ sessionId: processingSessionIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
